export default __webpack_public_path__ + "static/media/Path 138.95ade6ee.svg";